module.exports = __webpack_public_path__ + "static/media/pork_hero.fa0a0df5.jpg";